// extracted by mini-css-extract-plugin
export default {"button":"button-ui_button__1x0nR"};